package services.auth.http

import it.neckar.lizergy.model.company.user.UserInformation
import it.neckar.user.UserPassword
import kotlinx.serialization.Serializable

/**
 * The request to add a new user
 */
@Serializable
data class AddNewUserRequest(
  val userInformation: UserInformation,
  val password: UserPassword,
) {

  companion object {
    val example: AddNewUserRequest = AddNewUserRequest(
      userInformation = UserInformation.example,
      password = UserPassword("the-password"),
    )
  }
}
